import DropdownV1 from "../../../../components/form_builder/elements/dropdown/DropdownV1.vue";
import { validateRequired } from "../../../../helpers/validation";

export default {
  componentName: "fb-dropdown-v1",
  component: DropdownV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      options: ["Option 1", "Option 2"],
      description: "",
      value: "",
      required: false,
      hidden: false,
      multiselect: false,
      style: {},
      eFormEditable: true,
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    width: 100,
    template: ({ value }) => value
  },
  getValueReport: value => {
    return value;
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && !validateRequired(value))
      errors.push("This field is required");
    return errors;
  }
};
